/**
 * Safe navigation targets for configurable carousel slides.
 */

const HTTP_PREFIX = /^https?:\/\//i;
const MAILTO_PREFIX = /^mailto:/i;

/**
 * @param {unknown} href
 * @returns {boolean}
 */
export function isAllowedCarouselHref(href) {
  if (typeof href !== "string") return false;
  const t = href.trim();
  if (!t) return false;
  if (HTTP_PREFIX.test(t) || MAILTO_PREFIX.test(t)) return true;
  if (t.startsWith("/") && !t.startsWith("//")) return true;
  return false;
}

/**
 * @param {string} href
 * @returns {() => void}
 */
export function createButtonClickForHref(href) {
  return () => {
    const t = typeof href === "string" ? href.trim() : "";
    if (!isAllowedCarouselHref(t)) {
      console.warn("mapCarousel: blocked or invalid href", href);
      return;
    }
    if (HTTP_PREFIX.test(t) || MAILTO_PREFIX.test(t)) {
      window.open(t, "_blank", "noopener,noreferrer");
      return;
    }
    window.location.href = t;
  };
}

/**
 * Open carousel href in a new tab (admin “test link”). App paths use current origin.
 * @param {unknown} href
 * @returns {boolean} true if a tab was opened
 */
export function openCarouselHrefInNewTab(href) {
  const t = typeof href === "string" ? href.trim() : "";
  if (!isAllowedCarouselHref(t)) {
    console.warn("mapCarousel: blocked or invalid href (new tab)", href);
    return false;
  }
  if (HTTP_PREFIX.test(t) || MAILTO_PREFIX.test(t)) {
    window.open(t, "_blank", "noopener,noreferrer");
    return true;
  }
  const absolute = `${window.location.origin}${t}`;
  window.open(absolute, "_blank", "noopener,noreferrer");
  return true;
}
